import {css} from "lit";
import {commonStyles} from "../../common/styles/Common.js";
import {iconStyles} from "../../common/styles/Icons.js";

export const annotationStyles = [commonStyles, iconStyles, css`
	.annotation-list-item {
		box-sizing: border-box;
		display: block;
		list-style: none;
		position: relative;
		padding: 10px;
		background-color: var(--pn-outline-annotation-bg-color);
		border: 1px solid var(--pn-outline-annotation-border-color);
	}
	.annotation-list-item:hover,
	.annotation-list-item:focus,
	.annotation-list-item:focus-within {
		border-color: var(--pn-outline-annotation-border-color-hover);
		box-shadow: 0 2px 4px rgba(0,0,0,.5);
	}

	.annotation-list-item:hover .pn-comments-toggler:not(.has_comments),
	.annotation-list-item:focus .pn-comments-toggler:not(.has_comments),
	.annotation-list-item:focus-within .pn-comments-toggler:not(.has_comments),
	.annotation-list-item:hover pn-annotation-menu,
	.annotation-list-item:focus pn-annotation-menu,
	.annotation-list-item:focus-within pn-annotation-menu {
		opacity: 1;
	}

	.annotation-list-item > * {
		transition: .2s opacity;
	}

	[class*="icon-citation-"]  {
		width: 15px;
		height: 15px;
		cursor: pointer;
	}

	pn-annotation-menu {
		opacity: 0;
	}
	.integration-proquest pn-annotation-menu {
		opacity: 1;
	}

	/* Footer */
	.footer {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		position: relative;
	}

	.footer > * + * {
		margin-left: 6px;
	}

	.footer .page-title {
		flex: 1;
	}

	.footer .icon-bookmark-solid {
		background-color: var(--pn-color-bookmark);
	}

	.page-title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: calc(var(--pn-font-size-small) - 1px);
	}

	pn-annotation-menu {
		position: absolute;
		top: 10px;
		right: 1px;
		vertical-align: inherit;
		width: min-content;
	}

	pn-annotation-menu ::part(menu) {
		left: auto;
		right: 0;
	}

	/* Comments */
	.aa-annotation-comment .loading-text {
		text-align: right;
		font-size: var(--pn-font-size-small);
	}

	.pn-comments-toggler button {
		font-size: calc(var(--pn-font-size-base) + 1px);
		padding: 2px;
		margin-right: -2px;
	}

	/* Three dots menu */
	.dropdown > .dropdown-menu {
		right: 0;
		left: auto;
	}

	/* Mode: sidebar drag */
	.annotation-list-item.mode-sidebar-drag, .annotation-list-item.mode-sidebar-drag pn-rte::part(rte-container) {
		cursor: grab;
	}

	/* Mode: sidebar readonly */
`];
